export const NAME = 'WalletAccess';

export class WalletAccessError extends Error {
  constructor(message?: string) {
    super(message || NAME);
    this.name = NAME;
  }
}
